var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import theme from '../../theme';
import { LegacyHeadlineWithIcon } from './LegacyHeadlineWithIcon';
var LegacyHeadlinesWithIconsStyled = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  padding: 10px 0 10px 0;\n  text-align: center;\n  margin: auto;\n  @media (min-width: 768px) AND (max-width: 1140px) {\n    display: flex;\n    justify-content: space-between;\n  }\n"], ["\n  background-color: ", ";\n  padding: 10px 0 10px 0;\n  text-align: center;\n  margin: auto;\n  @media (min-width: 768px) AND (max-width: 1140px) {\n    display: flex;\n    justify-content: space-between;\n  }\n"])), theme.primaryColours.aubergine.main);
export var LegacyHeadlinesWithIcons = function (_a) {
    var _b = _a.headlines, headlines = _b === void 0 ? [] : _b, className = _a.className;
    return (_jsx(LegacyHeadlinesWithIconsStyled, __assign({ className: className }, { children: headlines.map(function (headline, i) { return (_jsx(LegacyHeadlineWithIcon, __assign({ className: "headline-item" }, headline), i)); }) })));
};
var templateObject_1;
